module.exports = __webpack_public_path__ + "static/media/21.628d957f.jpeg";